import CaseReportError from './CaseReportError'

export default CaseReportError
